// src/utils/avatarUtils.js

/**
 * Get initials from a full name
 * @param {string} fullName - The full name (e.g., "John Doe")
 * @returns {string} - The initials (e.g., "JD")
 */
export const getInitials = (fullName) => {
  if (!fullName) return "U";

  const names = fullName.trim().split(" ");
  
  if (names.length === 1) {
    // Single name: return first 2 characters
    return names[0].substring(0, 2).toUpperCase();
  }
  
  // Multiple names: return first letter of first and last name
  const firstInitial = names[0].charAt(0).toUpperCase();
  const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
  
  return firstInitial + lastInitial;
};

/**
 * Generate a consistent color based on the name
 * @param {string} fullName - The full name
 * @returns {string} - A hex color code
 */
export const getAvatarColor = (fullName) => {
  if (!fullName) return "#9e9e9e";

  // Generate a hash from the name
  let hash = 0;
  for (let i = 0; i < fullName.length; i++) {
    hash = fullName.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Convert hash to a color
  const colors = [
    "#f44336", // red
    "#e91e63", // pink
    "#9c27b0", // purple
    "#673ab7", // deep purple
    "#3f51b5", // indigo
    "#2196f3", // blue
    "#03a9f4", // light blue
    "#00bcd4", // cyan
    "#009688", // teal
    "#4caf50", // green
    "#8bc34a", // light green
    "#ff9800", // orange
    "#ff5722", // deep orange
    "#795548", // brown
  ];

  const index = Math.abs(hash) % colors.length;
  return colors[index];
};
